import { render, staticRenderFns } from "./AddSalesInvoiceRow.vue?vue&type=template&id=1c460952"
import script from "./AddSalesInvoiceRow.vue?vue&type=script&lang=ts"
export * from "./AddSalesInvoiceRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports